import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import * as React from 'react';

var _excluded = ["title", "titleId"];
var X12 = function X12(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    viewBox: "0 0 12 12",
    width: 12,
    height: 12,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M11 2.06 9.92 1 6 4.94 2.06 1 1 2.06 4.94 6 1 9.93 2.06 11 6 7.06l3.93 3.93L11 9.93 7.06 6z"
  }));
};
X12.Size = 12;
X12.Title = "X";

export { X12 as X };
//# sourceMappingURL=X12-12b3bb05.js.map
